import { render, staticRenderFns } from "./ExercisedFor.vue?vue&type=template&id=6b3cc252&scoped=true&"
import script from "./ExercisedFor.vue?vue&type=script&lang=js&"
export * from "./ExercisedFor.vue?vue&type=script&lang=js&"
import style0 from "./ExercisedFor.vue?vue&type=style&index=0&id=6b3cc252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3cc252",
  null
  
)

export default component.exports